import { useMemo } from "react";
import { useGetCurrentPublicAccountInfoByCurrentSlug } from "~auth/queries/use-get-public-account-info-by-slug";
import {
	DEFAULT_NEUTRAL_LOADING_LOGO_URL,
	resolveLoadingLogoUrl,
} from "~utils/functions/whitelabel-branding";

export const useLoadingLogoUrl = () => {
	const { data: publicAccountInfo, isSuccess } =
		useGetCurrentPublicAccountInfoByCurrentSlug();

	const logoUrl = useMemo(() => {
		if (!isSuccess) return undefined;
		return resolveLoadingLogoUrl(publicAccountInfo?.brandingConfig);
	}, [isSuccess, publicAccountInfo?.brandingConfig]);

	return {
		fallbackLogoUrl: DEFAULT_NEUTRAL_LOADING_LOGO_URL,
		logoUrl,
	};
};
